import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import { Col, Table } from 'react-bootstrap';
import DashboardContext from '../../../Context';
import Loader from '../../layout/Loader';
import '../tabel.css';
import Activation from 'components/forms/missionActions/Activation';

/**
 * این کامپوننت برای نمایش جدول در بخش نیرو است که لینک اسم نیرو به پروفایل نیرو را دارد
 */
export default function TablePriceList({
  urldata,
  params,
  refreshPriceTable,
  setLoadingOff,
}) {
  const {
    sideBardata,
    authentication,
    urldashboard,
    handelloding,
    dataFromTabel,
    searchLoading,
  } = useContext(DashboardContext);

  const [dataFech, setDataFech] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rowId, setRowId] = useState('');
  const [deleteitem, setDeleteitem] = useState(false);
  const [activationModal, setActivationModal] = useState(false);

  const datafeching = async () => {
    try {
      var url = `${urldashboard}${urldata}?groupId=${params}`;

      const res = await Axios.get(url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });

      const data = await res.data;

      setDataFech(data.data);
      setLoadingOff();
      setLoader(false);
      handelloding(false);
    } catch (error) {}
  };

  useEffect(() => {
    datafeching();
  }, [deleteitem, dataFromTabel, searchLoading, refreshPriceTable]);

  return (
    <>
      {sideBardata.length > 0 ? (
        <>
          {dataFech.length > 0 ? (
            <>
              <div style={{ marginTop: 15 }}>
                <Table hover bordered>
                  <thead>
                    <tr style={{ backgroundColor: '#ffe4e4' }}>
                      <th style={{ width: 20, textAlign: 'center' }}>ردیف</th>
                      <th style={{ textAlign: 'center' }}>روش ثبت سفارش</th>
                      <th style={{ textAlign: 'center' }}>نوع شیفت</th>
                      <th style={{ textAlign: 'center' }}>از تاریخ</th>
                      <th style={{ textAlign: 'center' }}>تا تاریخ</th>
                      <th style={{ textAlign: 'center' }}>پورسانت آقا</th>
                      <th style={{ textAlign: 'center' }}>پورسانت خانم</th>
                      <th style={{ textAlign: 'center' }}>مبلغ پایه آقا</th>
                      <th style={{ textAlign: 'center' }}>مبلغ پایه خانم</th>
                      <td style={{ textAlign: 'center' }}>هزینه ساعتی آقا</td>
                      <td style={{ textAlign: 'center' }}>هزینه ساعتی خانم</td>
                      <td style={{ textAlign: 'center' }}>حداقل ساعت آقا</td>
                      <td style={{ textAlign: 'center' }}>حداقل ساعت خانم</td>
                      <td style={{ textAlign: 'center' }}>مقدار ساعت کار از</td>
                      <td style={{ textAlign: 'center' }}>مقدار ساعت کار تا</td>
                      <td style={{ textAlign: 'center' }}>فعال/غیرفعال</td>
                    </tr>
                  </thead>

                  <tbody>
                    {dataFech.map((item, index) => {
                      return (
                        <>
                          <tr>
                            <td style={{ width: 20, textAlign: 'center' }}>
                              {++index}
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.orderRegistrationTypeTitle}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.dailyTypeTitle}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.persianFromDate}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.persianToDate}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.maleCommission}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.femaleCommission}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.maleBaseAmount}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.femaleBaseAmount}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.maleCostPerHour}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.femaleCostPerHour}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.maleMinimumTime}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.femaleMinimumTime}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.fromHour}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Col>{item.toHour}</Col>
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <button
                                className={
                                  item?.isActive
                                    ? 'btn btn-danger'
                                    : 'btn btn-success'
                                }
                                onClick={() => {
                                  setRowId(item?.id);
                                  setActivationModal(true);
                                }}
                              >
                                {item?.isActive ? 'غیرفعالسازی' : 'فعالسازی'}
                              </button>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>چیزی یافت نشد :(</div>
          )}
        </>
      ) : (
        <Loader />
      )}

      {activationModal && (
        <Activation
          itIsBootstrap
          title={'فعال/غیرفعال کردن قیمت'}
          controller={`priceList/activeOrDeactive?id=${rowId}`}
          openModal={activationModal}
          close={() => {
            setActivationModal(false);
            setRowId('');
            datafeching();
          }}
        />
      )}
    </>
  );
}
